/**
 * Small online/offline/ready badge. Non-interactive; hidden while online.
 * The element (#offline-indicator) lives in index.html.
 */
export class OfflineIndicator {
  private el: HTMLElement | null;

  constructor() {
    this.el = typeof document !== 'undefined' ? document.getElementById('offline-indicator') : null;
    this.update();
    if (typeof window !== 'undefined') {
      window.addEventListener('online', this.update);
      window.addEventListener('offline', this.update);
    }
  }

  private set(state: 'online' | 'offline' | 'ready', text: string): void {
    if (!this.el) return;
    this.el.dataset.state = state;
    this.el.textContent = text;
  }

  private update = (): void => {
    const online = typeof navigator === 'undefined' ? true : navigator.onLine;
    if (online) this.set('online', '');
    else this.set('offline', 'Offline — you can still color');
  };

  /** Briefly signal that the app is cached and ready to work offline. */
  flashOfflineReady(): void {
    this.set('ready', 'Ready to play offline');
    setTimeout(() => this.update(), 2200);
  }

  dispose(): void {
    if (typeof window !== 'undefined') {
      window.removeEventListener('online', this.update);
      window.removeEventListener('offline', this.update);
    }
  }
}
